import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { SEOHead } from "@/components/SEOHead";

/**
 * Client-side alias redirect that also emits a rel=canonical + noindex head
 * so crawlers (which cannot follow the SPA navigation) consolidate signals
 * to the target URL instead of indexing this alias as duplicate content.
 *
 * Use in place of `<Navigate to="…" replace />` for public URLs that appear
 * in the sitemap, GSC, or external backlinks.
 */
export function RedirectWithCanonical({ to, title }: { to: string; title?: string }) {
  const navigate = useNavigate();
  useEffect(() => {
    navigate(to, { replace: true });
  }, [to, navigate]);
  return (
    <SEOHead
      title={title ?? "Redirecting…"}
      description="This page has moved. You are being redirected to the current location."
      canonicalPath={to.split("?")[0]}
      noIndex
    />
  );
}

export default RedirectWithCanonical;